import { apolloProvider } from '@/modules/GraphQL';
import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { MYSTAGE_RECORDING, MYSTAGE_RECORDING_MSB } from '@/graphql/Mystage/recording';
import { bizmatesApi } from '@/utils/bizmatesApi';
import logger from '@/modules/Logger';
import qs from 'qs';
import { providerIds, providerNames }  from '@/utils/constants';
import store from '@/store';

export const RecordingService = {
  // Fetch HTML material from new MSB endpoint
  msb: async (params, callback) => {
    if (store.getters.isZipanService) {
      callback({
        status: false,
        message: 'Recording disabled for Zipan service',
        skipped: true
      });

      return;
    }
    
    logger.debug(`[MyStage][Recording] Start Recording from new MSB endpoint`, {
      operation: 'recording:mystage_recording',
      webrtc_id: params['webRTCId']
    });

    const client = myStageApolloProvider.defaultClient;
    const { data } = await client.mutate({
      mutation: MYSTAGE_RECORDING_MSB,
      variables: {
        b: parseInt(params['lessonId']),
      }
    });

    if (data?.executeRecording) {
      if (data.executeRecording.status) {
        logger.debug('[MyStage][Recording]['+providerNames[params['webRTCId']]+'] Recording is running...');
      } else {
        logger.debug('[MyStage][Recording]['+providerNames[params['webRTCId']]+'] Recording is not running... ' + data.executeRecording.message);
      }
      callback(data.executeRecording);
    } else {
      logger.error(`[MyStage][Recording] Failed to ping recording state`, {
        operation: 'recording:mystage_recording',
        event_type: 4,
        lesson_id: params['lessonId']
      });
    }
  },

  // Method to fetch PDF from new GraphQL endpoint
  mbti: async (params, callback) => {
    logger.debug(`[MyStage][Recording] Start Recording from MBTI GraphQL endpoint`, {
      operation: 'recording:mystage_recording',
      webrtc_id: params['webRTCId']
    });

    const client = apolloProvider.defaultClient;
    const { data } = await client.mutate({
      mutation: MYSTAGE_RECORDING,
      variables: {
        b: parseInt(params['lessonId']),
      }
    });

    if (data?.mystage_recording) {
      if (data.mystage_recording.status) {
        logger.debug('[MyStage][Recording]['+providerNames[params['webRTCId']]+'] Recording is running...');
      } else {
        logger.debug('[MyStage][Recording]['+providerNames[params['webRTCId']]+'] Recording is not running... ' + data.mystage_recording.message);
      }
      callback(data.mystage_recording);
    } else {
      logger.error(`[MyStage][Recording] Failed to ping recording state`, {
        operation: 'recording:mystage_recording',
        event_type: 4,
        lesson_id: params['lessonId']
      });
    }
  },

  // Method to trigger recording API directly based on webrtc_provider
  legacy: async (params, callback) => {
    logger.debug(`[MyStage][Recording][Legacy] Start Recording from legacy endpoint`, {
      operation: 'recording:legacy',
      webrtc_id: params['webRTCId']
    });

    try {
      if (params['webRTCId'] === providerIds.agora) {
        // Call Agora recording API
        await bizmatesApi.post('lesson/agoraRecording', qs.stringify(params), {},
          response => {
            if (response.data.status) {
              logger.debug('[MyStage][Recording][Agora Cloud] Recording is running...');
              callback(response.data);
            } else {
              logger.debug('[MyStage][Recording][Agora Cloud] Recording is not running... ' + response.data.message);
            }
          },
          error => {
            logger.error('[Recording][Agora Cloud] Failed to start recording', { error });
          }
        );
      } else if (params['webRTCId'] === providerIds.awschime) {
        // Call AWS Transcribe API
        await bizmatesApi.post('lesson/transcribe', qs.stringify(params), {},
          response => {
            logger.debug('[MyStage][Recording][AWS Transcribe] Transcription is running...');
            callback(response.data);
          },
          error => {
            logger.error('[MyStage][Recording][AWS Transcribe] Failed to start transcription', { error });
          }
        );
      } else {
        logger.warn(`[MyStage][Recording][Legacy] Unsupported webrtc_provider: ${params['webRTCId']}`, {
          operation: 'recording:legacy'
        });
      }
    } catch (error) {
      logger.error('[MyStage][Recording][Legacy] Unexpected error occurred', { error });
    }
  }
};
